import React, { Component } from "react";

import Create from "./Create";

export default class FormContainer extends Component {
    render () {
        let {
            actions,
            
            isLoadingAction,

            formType,
            selectedData,

            cardType,
            cardName,
            cardImg
        } = this.props;

        switch (formType.toUpperCase()) {
            case "CREATE":
            case "UPDATE":
            case "DUPLICATE":
                return <Create {...{
                    actions,
                    
                    isLoadingAction,

                    cardType,
                    cardName,
                    cardImg
                }}/>
                break;
            case "DELETE":
                return <p>Are you sure you want to delete {selectedData && selectedData.get("cardName") ? <span style={{ color: "red" }}>{selectedData.get("cardName")}</span> : "this data"}?</p>;
                break;
            default:
                return "";
        }
    }

    componentWillUnmount () {
        this.props.actions.setValue({
            selectedData: null,
            formType: "",
            formId: "",
            formTitle: "",

            cardType: "",
            cardName: "",
            cardImg: null
        });
    }
}


// WEBPACK FOOTER //
// ./components/CardImages/FormContainer/index.js